import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';
import { InputHeights } from '../../utils/consts';

export const TextFieldInput = ({
  value,
  onChange,
  onKeyDown,
  disabled,
  loading,
  testId,
  label,
  placeholder,
  autoFocus,
  isMultiline,
  rows = 0,
  maxRows,
  width = '100%',
  height = InputHeights.MEDIUM,
  error,
  helperText,
  onBlur,
  inputProps,
  InputProps,
  InputLabelProps,
  type = 'text',
  className,
  inputRef,
  autoComplete = 'off'
}) => {
  const handleKeyDown = event => {
    // Prevent typing the minus sign (-)
    if (type === 'number' && event.key === '-') {
      event.preventDefault();
    }
    if (isMultiline && rows > 1 && type === 'text' && event.key === 'Enter') {
      event.stopPropagation(); // prevent submit
    }
  };

  return (
    /* eslint-disable react/jsx-no-duplicate-props */
    <S.TextFieldWrapper className={className}>
      <S.StyledTextField
        onKeyDown={onKeyDown || handleKeyDown}
        type={type}
        value={value}
        $width={width}
        $height={height}
        label={label && label}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        size="small"
        margin="none"
        data-testid={testId}
        placeholder={placeholder}
        autoFocus={autoFocus}
        multiline={isMultiline || rows > 1}
        rows={rows}
        maxRows={maxRows}
        error={error}
        helperText={helperText}
        onBlur={onBlur}
        inputProps={inputProps}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
        inputRef={inputRef}
      />
      {loading && <S.LoadingIcon size={16} color="var(--button-loading-icon-color)" rotate />}
    </S.TextFieldWrapper>
  );
};

TextFieldInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  testId: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isMultiline: PropTypes.bool,
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.oneOf(['LARGE', 'MEDIUM', 'SMALL', 'TINY', PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['number', 'password', 'text']),
  error: PropTypes.bool,
  helperText: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  inputProps: PropTypes.any,
  InputProps: PropTypes.any,
  InputLabelProps: PropTypes.any,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
};
